import { projectNameMap } from '@constants'
import { Image } from '@pets-ui/Image/Image'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { brandImageMap, type BrandInfo } from '../../constants'

interface BrandCardProps {
  brand: BrandInfo
  customLogoUrl?: string
  onClick?: (brand: BrandInfo) => void
}

export const BrandCard = (props: BrandCardProps) => {
  const { brand, customLogoUrl, onClick } = props
  const brandName = projectNameMap[brand.projectCode] ?? brand.projectCode

  const iconSrc = customLogoUrl || brandImageMap[brand.projectCode]?.icon

  return (
    <VStack width={80} gap={2} alignItems="center" cursor="pointer" onClick={() => onClick?.(brand)}>
      <Image src={iconSrc} alt={brandName} width={80} height={80} borderRadius={16} />
      <Text color={colors.grey800} noWrap>
        {brandName}
      </Text>
    </VStack>
  )
}
